import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './../../styles/admin/Sidebar.css';

const Sidebar = () => {
    return (
        <div className="sidebar">
            <ul>
                <li>
                    <NavLink to="/admin/menus">Menu semanal</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/platillos">Platillos</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/pedidos">Pedidos</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/cupones">Cupones</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/pagos">Pagos</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/clientes">Clientes</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/referidos">Referidos</NavLink>
                </li>
                <li>
                    <NavLink to="/admin/reportes">Reportes</NavLink>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;